import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { GoogleButton, AuthDivider } from "@/components/GoogleButton";
import { LOGO_URL } from "@/lib/constants";

const AUTH_BG = "https://images.unsplash.com/photo-1618898613684-2cf0ae9a7c19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHNvZnQlMjBncmVlbiUyMG9yZ2FuaWMlMjBzaGFwZXMlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4MjkxMTI1NXww&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await login(email, password); nav("/dashboard"); }
    catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen">
      <div className="hidden w-1/2 lg:block" style={{ backgroundImage: `url(${AUTH_BG})`, backgroundSize: "cover", backgroundPosition: "center" }}>
        <div className="flex h-full flex-col justify-between bg-[#0F2A5C]/60 p-12 text-white">
          <div className="inline-flex w-fit rounded-xl bg-white p-3 shadow-sm">
            <img src={LOGO_URL} alt="Tolulope Bello — Wealth Builder Hub" className="h-12 w-auto object-contain" />
          </div>
          <div>
            <h2 className="font-head text-4xl font-medium leading-tight tracking-tight">Learn. Invest. Grow. Build wealth that lasts.</h2>
            <p className="mt-4 max-w-md text-white/90">Stocks, ETFs and funds across the US, UK, Nigeria, Canada, Europe, Asia, Africa & Australia.</p>
          </div>
        </div>
      </div>
      <div className="flex w-full items-center justify-center px-6 lg:w-1/2">
        <div className="w-full max-w-sm">
          <h1 className="font-head text-3xl font-medium tracking-tight text-stone-900">Welcome back</h1>
          <p className="mt-2 text-stone-500">Sign in to continue your research.</p>
          <div className="mt-8"><GoogleButton /></div>
          <AuthDivider />
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-semibold uppercase tracking-[0.15em] text-stone-500">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 flex h-12 w-full rounded-lg border border-stone-200 bg-white px-4 text-sm focus:outline-none focus:ring-2 focus:ring-navy/20" placeholder="you@example.com" />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-[0.15em] text-stone-500">Password</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 flex h-12 w-full rounded-lg border border-stone-200 bg-white px-4 text-sm focus:outline-none focus:ring-2 focus:ring-navy/20" placeholder="••••••••" />
            </div>
            {error && <p data-testid="login-error" className="text-sm text-rose-600">{error}</p>}
            <button data-testid="login-submit" disabled={loading} type="submit"
              className="flex h-12 w-full items-center justify-center rounded-lg bg-navy text-sm font-medium text-white transition-colors hover:bg-navyd disabled:opacity-60">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <p className="mt-6 text-sm text-stone-500">No account? <Link to="/signup" data-testid="go-signup" className="font-medium text-navy hover:underline">Create one</Link></p>
          <p className="mt-2 text-xs text-stone-400">Demo: admin@globalinvest.com / admin123</p>
        </div>
      </div>
    </div>
  );
}
